/** @flow */
import moment from 'moment';

export type StepInMinutes = 5 | 15 | 30 | 60;
export const ALL_METRICS_INTERVAL_STEPS: StepInMinutes[] = [5, 15, 30, 60];

interface IntervalData {
  from: moment;
  to: moment;
  step: StepInMinutes;
}

export class Interval implements IntervalData {
  from: moment;
  to: moment;
  step: StepInMinutes;

  constructor({ from, to, step }: IntervalData) {
    this.from = from;
    this.to = to;
    this.step = step;
  }

  toJSON() {
    return {
      from: this.from.toISOString(),
      to: this.to.toISOString(),
      step: this.step,
    };
  }

  static fromJSON(data: Object) {
    return new Interval({
      from: moment(data.from),
      to: moment(data.to),
      step: data.step,
    });
  }
}

export type DateRange = {
  from: moment;
  to: moment;
};



// WEBPACK FOOTER //
// ./src/statsradio/domain/reach.js